import { render, staticRenderFns } from "./NewArticle.pug?vue&type=template&id=17117f26&external"
import script from "./NewArticle.js?vue&type=script&lang=js&external"
export * from "./NewArticle.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports